import React from 'react';
import Link from 'shared/components/Link';
import iThenticateLogo from '../../../images/ithenticate.svg';
import { FEATURE_LIST_TERMS, PLAGIARISM_PATH } from '../pricingContent';
import usePricingCopy from '../usePricingCopy';
import { COMPACT_BUTTON, OUTLINE_BUTTON } from './buttonClasses';
import PlagiarismStrip from './PlagiarismStrip';
import PlanCard from './PlanCard';
import '../pricing.scss';
var PricingLayout = function PricingLayout(_ref) {
  var toggle = _ref.toggle,
    planCards = _ref.planCards,
    groupUrl = _ref.groupUrl,
    plagiarism = _ref.plagiarism;
  var _usePricingCopy = usePricingCopy(),
    page = _usePricingCopy.page,
    group = _usePricingCopy.group,
    plagiarismCopy = _usePricingCopy.plagiarism;
  return /*#__PURE__*/React.createElement("div", {
    className: "rubriq-pricing w-100"
  }, /*#__PURE__*/React.createElement("main", {
    className: "pricing-main w-75 mx-auto curie-more-options g-padding"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pricing-header text-center"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "fw-semibold"
  }, page.title), /*#__PURE__*/React.createElement("p", null, page.subtitle)), toggle, /*#__PURE__*/React.createElement("div", {
    className: "pricing-cards d-flex"
  }, planCards, /*#__PURE__*/React.createElement(PlanCard, {
    title: group.title,
    pill: group.pill,
    price: group.price,
    featuresPrefix: page.featuresPrefix,
    featuresTerm: FEATURE_LIST_TERMS.group,
    action: /*#__PURE__*/React.createElement("a", {
      className: OUTLINE_BUTTON,
      href: groupUrl
    }, group.buttonLabel)
  })), plagiarism && /*#__PURE__*/React.createElement("div", {
    className: "mt-5 mb-4"
  }, /*#__PURE__*/React.createElement("p", {
    className: "pricing-more-plans-label fw-semibold text-uppercase"
  }, page.morePlans), /*#__PURE__*/React.createElement(PlagiarismStrip, {
    title: plagiarismCopy.title,
    poweredBy: plagiarismCopy.poweredBy,
    logo: iThenticateLogo,
    price: plagiarism.price,
    priceNote: plagiarismCopy.priceNote,
    featuresTerm: FEATURE_LIST_TERMS.plagiarism,
    action: /*#__PURE__*/React.createElement(Link, {
      className: COMPACT_BUTTON,
      to: PLAGIARISM_PATH,
      state: {
        source: 'pricing_page'
      },
      onClick: plagiarism.onSelect
    }, plagiarismCopy.buttonLabel)
  }))));
};
export default PricingLayout;